import React, { useEffect, useRef, useState } from "react";
import "./styles.css" ;


const Carousel = ({ images }) => {

  const carouselRef = useRef(null);
  const trackRef = useRef(null);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!carouselRef.current || !trackRef.current) return;

    const carousel = carouselRef.current;
    const track = trackRef.current;
    const items = track.children;
    const totalItems = items.length;

    if (!items[0]) return;

    const carouselWidth = carousel.offsetWidth;
    const itemWidth = items[0].offsetWidth + 24; // SAME GAP AS HTML
    const trackWidth = track.scrollWidth;

    let translateX = 0;

    // ✅ SAME LOGIC AS YOUR HTML
    if (index === totalItems - 1) {
      translateX = trackWidth - carouselWidth;
    } else {
      translateX = index * itemWidth;
    }

    track.style.transform = `translateX(-${translateX}px)`;
  }, [index]);

  // Auto-scroll (same as HTML)
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) =>
        prev === images.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="carouselRx mt-48" ref={carouselRef}>
      <div className="carousel-track" ref={trackRef}>
        {images.map((src, i) => (
          <div className="carousel-item" key={i}>
            <img src={src} alt={`slide-${i}`} />
          </div>
        ))}
      </div>

      {/* INDICATORS */}
      <div className="indicators">
        {images.map((_, i) => (
          <div
            key={i}
            className={`indicator ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
